import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ref"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useResizeDetector } from 'react-resize-detector';
import usePrevious from './hooks/usePrevious';
import Context from '@gisatcz/cross-package-react-context';
import TimelineContent from './TimelineContent';
import { jsx as _jsx } from "react/jsx-runtime";
var CONTROLS_WIDTH = 0;
var DEFAULT_SIZE = 100;
export var LEVELS = [{
  end: 1,
  level: 'year'
}, {
  end: 10,
  level: 'month'
}, {
  end: 250,
  level: 'day'
}, {
  end: 15000,
  level: 'hour'
}, {
  end: 70000,
  level: 'minute'
}];
var DEFAULT_VERTICAL_HEIGHT = 70;
var DEFAULT_HORIZONTAL_HEIGHT = 45;

var Timeline = function Timeline(_ref) {
  var centerTime = _ref.centerTime,
      children = _ref.children,
      contentHeight = _ref.contentHeight,
      _ref$dayWidth = _ref.dayWidth,
      dayWidth = _ref$dayWidth === void 0 ? 1.5 : _ref$dayWidth,
      _ref$levels = _ref.levels,
      levels = _ref$levels === void 0 ? LEVELS : _ref$levels,
      onChange = _ref.onChange,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$onHover = _ref.onHover,
      onHover = _ref$onHover === void 0 ? function () {} : _ref$onHover,
      _ref$onHoverOut = _ref.onHoverOut,
      onHoverOut = _ref$onHoverOut === void 0 ? function () {} : _ref$onHoverOut,
      period = _ref.period,
      periodLimit = _ref.periodLimit,
      periodLimitOnCenter = _ref.periodLimitOnCenter,
      _ref$selectMode = _ref.selectMode,
      selectMode = _ref$selectMode === void 0 ? false : _ref$selectMode,
      time = _ref.time,
      vertical = _ref.vertical,
      onResize = _ref.onResize,
      width = _ref.width;
  var defaultHoverContext = 'TimeLineContext';
  var HoverContext = Context.getContext(defaultHoverContext); // constructor(props) {
  // 	super(props);
  // 	this.updateContext = this.updateContext.bind(this);
  // 	this.getX = this.getX.bind(this);
  // 	this.getTime = this.getTime.bind(this);
  // 	this.getActiveLevel = this.getActiveLevel.bind(this);
  // const size = useResizeDetector();

  var _useResizeDetector = useResizeDetector(_objectSpread({
    refreshMode: 'debounce',
    refreshRate: 300,
    refreshOptions: {
      trailing: true
    }
  }, onResize ? {
    onResize: onResize
  } : {})),
      ref = _useResizeDetector.ref,
      size = _objectWithoutProperties(_useResizeDetector, _excluded);

  var widthSelf = width || size.width;
  var height = size.height || 100;
  var prevTime = usePrevious(time);
  var prevDayWidth = usePrevious(dayWidth);
  var prevPeriodLimit = usePrevious(periodLimit);
  var prevWidth = usePrevious(widthSelf);
  var prevHeight = usePrevious(height);

  var getXAxisWidth = function getXAxisWidth() {
    var _ref$current, _ref$current2;

    var XAxisWidth = vertical ? ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect().height : ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.getBoundingClientRect().width;
    return XAxisWidth || DEFAULT_SIZE;
  };

  var getPeriodLimitByDayWidth = function getPeriodLimitByDayWidth(dayWidth) {
    var allDays = getXAxisWidth() / dayWidth;
    var halfMouseDays = allDays / 2;
    var start = moment(centerTime).subtract(moment.duration(halfMouseDays * (60 * 60 * 24 * 1000), 'ms')).toDate().toString();
    var end = moment(centerTime).add(moment.duration(halfMouseDays * (60 * 60 * 24 * 1000), 'ms')).toDate().toString();
    return {
      start: start,
      end: end
    };
  };

  var getMaxDayWidth = function getMaxDayWidth() {
    var forLevels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : levels;
    var lastLevel = forLevels[forLevels.length - 1];
    var maxDayWidth = lastLevel.end;
    return maxDayWidth;
  };

  var getDayWidthForPeriod = function getDayWidthForPeriod(periodLimit, axesWidth) {
    var maxDayWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getMaxDayWidth();
    var start = moment(periodLimit.start);
    var end = moment(periodLimit.end);
    var diff = end.diff(start, 'ms');
    var diffDays = diff / (60 * 60 * 24 * 1000);
    var dayWidth = (axesWidth - CONTROLS_WIDTH) / diffDays;

    if (dayWidth > maxDayWidth) {
      dayWidth = maxDayWidth;
    }

    return dayWidth;
  }; //Find first level with smaller start level.


  var getActiveLevel = function getActiveLevel(dayWidth) {
    return levels.find(function (l) {
      return dayWidth <= l.end;
    });
  };

  var getTime = function getTime(x) {
    var dayWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : state.dayWidth;
    var startTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : state.period.start;
    var diffDays = x / dayWidth;
    var diff = diffDays * (60 * 60 * 24 * 1000);
    return moment(startTime).add(moment.duration(diff, 'ms'));
  };

  var getPeriodLimitByTime = function getPeriodLimitByTime(time) {
    var axesWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getXAxisWidth();
    var periodLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : state.periodLimit;
    var dayWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : state.dayWidth;
    var allDays = axesWidth / dayWidth;
    var setTime = moment(time); //check if setTime is in periodLimit

    if (setTime.isBefore(periodLimit.start)) {
      setTime = moment(periodLimit.start);
    }

    if (setTime.isAfter(periodLimit.end)) {
      setTime = moment(periodLimit.end);
    }

    var halfDays = allDays / 2;
    var start = moment(setTime).subtract(moment.duration(halfDays * (60 * 60 * 24 * 1000), 'ms')).toDate().toString();
    var end = moment(setTime).add(moment.duration(halfDays * (60 * 60 * 24 * 1000), 'ms')).toDate().toString();
    return {
      start: start,
      end: end
    };
  };

  var getStateUpdate = function getStateUpdate(options) {
    if (options) {
      var _updateContext = {};
      Object.assign(_updateContext, _objectSpread({}, options)); //on change dayWidth calculate period

      if (options.dayWidth) {
        Object.assign(_updateContext, {
          period: getPeriodLimitByDayWidth(options.dayWidth)
        });
      } //on change period calculate dayWidth


      if (options.period) {
        Object.assign(_updateContext, {
          dayWidth: getDayWidthForPeriod(options.period, getXAxisWidth())
        });
      }

      if (_updateContext.dayWidth) {
        Object.assign(_updateContext, {
          activeLevel: getActiveLevel(_updateContext.dayWidth, levels).level
        });
      }

      if (_updateContext.dayWidth && !options.centerTime && !options.lockCenter) {
        Object.assign(_updateContext, {
          centerTime: getTime(getXAxisWidth() / 2, _updateContext.dayWidth, _updateContext.period.start).toDate()
        });
      }

      if (options.centerTime && !_updateContext.period) {
        Object.assign(_updateContext, {
          period: getPeriodLimitByTime(options.centerTime, getXAxisWidth(), periodLimit, _updateContext.dayWidth)
        });
      }

      if (_updateContext.centerTime) {
        var utcTime = new Date(_updateContext.centerTime);
        utcTime.setTime(utcTime.getTime() - utcTime.getTimezoneOffset() * 60 * 1000);
        Object.assign(_updateContext, {
          centerTimeUtc: utcTime.toUTCString()
        });
      }

      return _updateContext;
    } else {
      return {};
    }
  };

  var _useState = useState(getStateUpdate({
    periodLimit: periodLimit,
    period: period || periodLimit,
    centerTime: time
  })),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    if (typeof onChange === 'function') {
      // fixme test if state is defined
      onChange(state);
    }
  }, []);
  useEffect(function () {
    // const {dayWidth, time, width, height, periodLimit} = this.props;
    var timeHasChanged = prevTime && time && prevTime.toString() !== time.toString() && state.centerTime.toString() !== time.toString(); //if parent component set dayWidth

    if (prevDayWidth !== dayWidth && state.dayWidth !== dayWidth && !timeHasChanged) {
      updateContext({
        dayWidth: dayWidth,
        centerTime: time
      });
    } //if parent component set time


    if (timeHasChanged) {
      var xAxis = getXAxisWidth();

      var _period = getPeriodLimitByTime(time, xAxis, state.periodLimit, dayWidth); //zoom to dayWidth


      updateContext({
        period: _period,
        centerTime: time
      });
    }

    if (prevPeriodLimit !== periodLimit) {
      updateContext({
        period: periodLimit,
        periodLimit: periodLimit
      });
    } //if parent component set time


    if (prevWidth !== widthSelf || prevHeight !== height) {
      //přepočítat day width aby bylo v periodě
      //todo take time from state
      // const period = this.getPeriodLimitByTime(time);
      var _xAxis = getXAxisWidth();

      var minPeriodDayWidth = getDayWidthForPeriod(periodLimit, _xAxis);
      var _dayWidth = state.dayWidth;

      if (minPeriodDayWidth >= state.dayWidth) {
        _dayWidth = minPeriodDayWidth;
      }

      var _period2 = getPeriodLimitByTime(state.centerTime, _xAxis, periodLimit, _dayWidth); //zoom to dayWidth


      updateContext({
        period: _period2
      });
    }
  }, [time, dayWidth, periodLimit, widthSelf, height]);

  var getX = function getX(date) {
    date = moment(date);
    var diff = date.unix() - moment(state.period.start).unix();
    var diffDays = diff / (60 * 60 * 24);
    return diffDays * state.dayWidth;
  };

  var updateContext = function updateContext(options) {
    if (options && height && widthSelf) {
      var stateUpdate = getStateUpdate(options); // setState(stateUpdate, () => {
      // 	if (typeof this.props.onChange === 'function') {
      // 		this.props.onChange(this.state);
      // 	}
      // });

      setState(_objectSpread(_objectSpread({}, state), stateUpdate)); // FIXME test

      if (typeof onChange === 'function') {
        onChange(_objectSpread(_objectSpread({}, state), stateUpdate));
      }
    }
  };

  var getContentHeight = function getContentHeight() {
    return contentHeight || (vertical ? DEFAULT_VERTICAL_HEIGHT : DEFAULT_HORIZONTAL_HEIGHT);
  }; // render() {
  // 	const {
  // 		levels,
  // 		periodLimit,
  // 		onHover,
  // 		onClick,
  // 		vertical,
  // 		children,
  // 		periodLimitOnCenter,
  // 		selectMode,
  // 	} = this.props;


  var stateDayWidth = state.dayWidth,
      statePeriod = state.period,
      mouseX = state.mouseX,
      moving = state.moving;
  var maxDayWidth = getMaxDayWidth();
  var activeDayWidth = stateDayWidth >= maxDayWidth ? maxDayWidth : stateDayWidth;
  var activeLevel = getActiveLevel(activeDayWidth, levels).level;
  var minDayWidth = getDayWidthForPeriod(periodLimit, getXAxisWidth());
  return /*#__PURE__*/_jsx("div", {
    className: "ptr-timeline",
    ref: ref,
    style: {
      width: widthSelf
    },
    children: /*#__PURE__*/_jsx(HoverContext.Provider, {
      value: {
        updateContext: updateContext,
        width: getXAxisWidth(),
        height: getContentHeight(),
        getX: getX,
        getTime: getTime,
        centerTime: state.centerTime,
        getActiveLevel: getActiveLevel,
        dayWidth: stateDayWidth,
        maxDayWidth: maxDayWidth,
        minDayWidth: minDayWidth,
        periodLimit: periodLimit,
        period: statePeriod,
        mouseX: mouseX,
        activeLevel: activeLevel,
        periodLimitVisible: true,
        onClick: onClick,
        onHover: onHover,
        onHoverOut: onHoverOut,
        vertical: vertical,
        periodLimitOnCenter: periodLimitOnCenter,
        selectMode: selectMode,
        moving: moving
      },
      children: /*#__PURE__*/_jsx(TimelineContent, {
        children: children
      })
    })
  });
};

Timeline.propTypes = {
  centerTime: PropTypes.object,
  children: PropTypes.node,
  contentHeight: PropTypes.number,
  dayWidth: PropTypes.number,
  height: PropTypes.number,
  levels: PropTypes.arrayOf(PropTypes.shape({
    end: PropTypes.number,
    level: PropTypes.string
  })),
  //ordered levels by higher level.end
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onHover: PropTypes.func,
  onHoverOut: PropTypes.func,
  period: PropTypes.shape({
    end: PropTypes.string,
    start: PropTypes.string
  }),
  periodLimit: PropTypes.shape({
    end: PropTypes.string,
    start: PropTypes.string
  }).isRequired,
  periodLimitOnCenter: PropTypes.bool,
  selectMode: PropTypes.bool,
  //whether change time while zoom
  time: PropTypes.object,
  vertical: PropTypes.bool,
  width: PropTypes.number,
  onResize: PropTypes.func
}; // export default withResizeDetector(Timeline);

export default Timeline;